export default "__VITE_ASSET__BiOf33R5__"